import { api } from "@shared/lib/api";
import { AddBy, BackednResponse, IUser } from "@shared/lib/types";
import {
  IBucket,
  IBucketFacets,
  IBucketResponse,
  ICreateBucketRequest,
  IBuckRequest,
} from "@shared/lib/types/influencer";

export class AuthService {
  public static async getBeUser() {
    const response = (await api
      .get("user/admin/me")
      .json()) as BackednResponse<IUser>;
    return response;
  }
}
